import { useEffect, useState } from "react";
import axios from "axios";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ContactInfoPanel = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    axios.get(`${API}/settings/public`).then((res) => setSettings(res.data)).catch(() => setSettings({}));
  }, []);

  const rows = [
    { icon: Phone, label: "Phone", value: settings?.contact_phone, href: settings?.contact_phone ? `tel:${settings.contact_phone}` : null, testId: "contact-info-phone" },
    { icon: Mail, label: "Email", value: settings?.contact_email, href: settings?.contact_email ? `mailto:${settings.contact_email}` : null, testId: "contact-info-email" },
    { icon: MessageCircle, label: "WhatsApp", value: settings?.contact_whatsapp, href: settings?.contact_whatsapp ? `https://wa.me/${settings.contact_whatsapp.replace(/\D/g, "")}` : null, testId: "contact-info-whatsapp" },
    { icon: MapPin, label: "Office", value: settings?.office_address, href: null, testId: "contact-info-address" },
  ];

  return (
    <div className="neu-panel p-8" data-testid="contact-info-panel">
      <span className="eyebrow block mb-6">Reach Us Directly</span>
      <div className="space-y-5 mb-8">
        {rows.map(({ icon: Icon, label, value, href, testId }) => (
          <div key={label} className="flex items-start gap-3" data-testid={testId}>
            <Icon size={18} style={{ color: "var(--gg-logo-gold)" }} className="mt-0.5 shrink-0" />
            <div>
              <p className="text-small font-semibold" style={{ color: "var(--gg-secondary-text)" }}>{label}</p>
              {value ? (
                href ? (
                  <a href={href} target={label === "WhatsApp" ? "_blank" : undefined} rel="noopener noreferrer" className="text-body link-quiet">{value}</a>
                ) : (
                  <p className="text-body">{value}</p>
                )
              ) : (
                <p className="text-small" style={{ color: "var(--gg-muted-text)" }}>Coming Soon</p>
              )}
            </div>
          </div>
        ))}
      </div>

      {settings?.google_maps_embed_url ? (
        <div className="neu-surface overflow-hidden" style={{ height: "220px" }} data-testid="contact-info-map">
          <iframe src={settings.google_maps_embed_url} title="Office location" className="w-full h-full border-0" loading="lazy" />
        </div>
      ) : (
        <div className="neu-inset flex items-center justify-center text-small" style={{ height: "160px", color: "var(--gg-muted-text)" }} data-testid="contact-info-map-placeholder">
          Map Coming Soon
        </div>
      )}
    </div>
  );
};

export default ContactInfoPanel;
